<template>
  <market-card :title="$t('pages.login.user.card_opening_hours.title')" class="market-hours">
    <market-opening-hours-list :market="market" />
    <p v-if="market.openingHoursExtraInfo" class="small text-muted pre-wrap mt-2 mb-0">
      {{ market.openingHoursExtraInfo }}
    </p>
  </market-card>
</template>

<script>
  import MarketOpeningHoursList from '@base/components/MarketOpeningHoursList.vue'
  import MarketCard from '@base/components/market/MarketCard.vue'

  export default {
    name: 'MarketHoursCard',

    components: {
      MarketCard,
      MarketOpeningHoursList,
    },

    props: {
      market: {
        type: Object,
        required: true,
      },
    },
  }
</script>

<style scoped>
  .market-hours ::v-deep .is-today {
    font-weight: 600;
  }

  .market-hours ::v-deep .is-today.is-open {
    color: var(--ui-brand);
  }
</style>
